// TodaySchedule.js
import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';

const TodaySchedule = () => {
  const navigation = useNavigation();
  
  const todaySchedule = [
    {
      id: '1',
      course: 'Python for Engineers',
      type: 'video',
      title: 'NumPy Arrays Tutorial',
      time: '10:00 AM - 11:30 AM',
      duration: '1.5 hours',
      status: 'upcoming',
    },
    {
      id: '2',
      course: 'Machine Learning',
      type: 'assignment',
      title: 'Assignment 3 Due',
      time: '2:00 PM',
      duration: null,
      status: 'urgent',
    },
    {
      id: '3',
      course: 'Structural Analysis',
      type: 'quiz',
      title: 'Weekly Quiz',
      time: '4:00 PM - 5:00 PM',
      duration: '1 hour',
      status: 'completed',
    },
  ];

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <MaterialCommunityIcons name="arrow-left" size={24} color="#1f2937" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Today's Schedule</Text>
        <MaterialCommunityIcons name="calendar" size={24} color="#667eea" />
      </View>

      <ScrollView style={styles.content}>
        <View style={styles.dateHeader}>
          <Text style={styles.dateText}>
            {new Date().toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </Text>
        </View>

        {todaySchedule.map((item) => (
          <TouchableOpacity
            key={item.id}
            style={[
              styles.scheduleItem,
              item.status === 'urgent' && styles.urgentItem,
              item.status === 'completed' && styles.completedItem,
            ]}
          >
            <View style={styles.itemIcon}>
              <MaterialCommunityIcons 
                name={
                  item.type === 'video' ? 'video' :
                  item.type === 'assignment' ? 'clipboard-text' :
                  'clipboard-check'
                } 
                size={24} 
                color={
                  item.status === 'urgent' ? '#ef4444' :
                  item.status === 'completed' ? '#10b981' : '#667eea'
                } 
              />
            </View>
            
            <View style={styles.itemContent}>
              <Text style={styles.courseName}>{item.course}</Text>
              <Text style={styles.itemTitle}>{item.title}</Text>
              <View style={styles.itemDetails}>
                <MaterialCommunityIcons name="clock-outline" size={14} color="#6b7280" />
                <Text style={styles.timeText}>{item.time}</Text>
                {item.duration && (
                  <>
                    <MaterialCommunityIcons name="timer-outline" size={14} color="#6b7280" />
                    <Text style={styles.durationText}>{item.duration}</Text>
                  </>
                )}
              </View>
            </View>
            
            {item.status === 'upcoming' && (
              <TouchableOpacity style={styles.joinButton}>
                <Text style={styles.joinButtonText}>Join</Text>
              </TouchableOpacity>
            )}
            
            {item.status === 'urgent' && (
              <TouchableOpacity style={styles.submitButton}>
                <Text style={styles.submitButtonText}>Submit</Text>
              </TouchableOpacity>
            )}
          </TouchableOpacity>
        ))}

        <View style={styles.studyTime}>
          <Text style={styles.studyTitle}>Recommended Study Time</Text>
          <Text style={styles.studyHours}>4.5 hours today</Text>
          <Text style={styles.studyProgress}>2.5 hours completed</Text>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  content: {
    flex: 1,
    padding: 16,
  },
  dateHeader: {
    marginBottom: 24,
  },
  dateText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  scheduleItem: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f3f4f6',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
  },
  urgentItem: {
    backgroundColor: '#fee2e2',
  },
  completedItem: {
    backgroundColor: '#d1fae5',
  },
  itemIcon: {
    marginRight: 16,
  },
  itemContent: {
    flex: 1,
  },
  courseName: {
    fontSize: 12,
    color: '#6b7280',
    marginBottom: 4,
  },
  itemTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: 8,
  },
  itemDetails: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  timeText: {
    fontSize: 12,
    color: '#6b7280',
    marginLeft: 4,
    marginRight: 12,
  },
  durationText: {
    fontSize: 12,
    color: '#6b7280',
    marginLeft: 4,
  },
  joinButton: {
    backgroundColor: '#667eea',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  joinButtonText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '600',
  },
  submitButton: {
    backgroundColor: '#ef4444',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  submitButtonText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '600',
  },
  studyTime: {
    backgroundColor: '#667eea',
    borderRadius: 16,
    padding: 20,
    marginTop: 20,
  },
  studyTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: 8,
  },
  studyHours: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: 4,
  },
  studyProgress: {
    fontSize: 14,
    color: 'rgba(255, 255, 255, 0.9)',
  },
});

export default TodaySchedule;